import { render, staticRenderFns } from "./AssetUploader.vue?vue&type=template&id=4463455a&"
import script from "./AssetUploader.vue?vue&type=script&lang=js&"
export * from "./AssetUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports